import { NavigationDto } from '@asset-metrix/portal-gateway-client-js';

import { matchesComparisonNavSession } from '../../utils/comparisonDetailPageNav';
import { COMPARISON_ENTITIES_URL_PARAM } from '../../utils/constants';
import { matchesPersistedDetailPageIdentity } from '../../utils/detailPageNavigationIdentity';
import { getDetailsFromSearchParams } from '../../utils/getDetailsFromSearchParams';

function pageSlugStartsWithItemSlug(pageSlug: string) {
  return (item: { completeSlug: string }) =>
    pageSlug.startsWith(`${item.completeSlug}/`) ||
    pageSlug === item.completeSlug;
}

export function getActiveItemIndex(
  navigationItems: { completeSlug: string }[],
  pageSlug: string
): number | undefined {
  const index = navigationItems.findIndex(pageSlugStartsWithItemSlug(pageSlug));
  return index === -1 ? undefined : index;
}

export function getActiveItem(
  navigationItems: NavigationDto['rootNavigationItems'],
  pageSlug: string
): NavigationDto['rootNavigationItems'][number] | undefined {
  return navigationItems.find(pageSlugStartsWithItemSlug(pageSlug));
}

export function getActiveDynamicItemIndex(
  navigationItems: { completeSlug: string }[],
  locationPathname: string,
  locationSearch: string
): number | undefined {
  const currentSearchParams = new URLSearchParams(locationSearch);
  const { detailsDiscriminator, detailsValue } =
    getDetailsFromSearchParams(currentSearchParams);

  if (detailsDiscriminator == null || detailsValue == null) {
    return undefined;
  }

  const matchingIndex = navigationItems.findIndex((dni) => {
    const dniUrl = new URL(dni.completeSlug, globalThis.location.origin);
    const dynamicItemSearchParams = new URLSearchParams(dniUrl.search);

    if (!locationPathname.startsWith(dniUrl.pathname)) {
      return false;
    }

    if (currentSearchParams.has(COMPARISON_ENTITIES_URL_PARAM)) {
      return matchesComparisonNavSession(
        dni.completeSlug,
        locationPathname,
        currentSearchParams
      );
    }

    return matchesPersistedDetailPageIdentity(
      dynamicItemSearchParams,
      currentSearchParams
    );
  });

  if (matchingIndex !== -1) {
    return matchingIndex;
  }

  // @deprecated 2026-04-08: Can be removed after reasonable time has passed and we expect users to have updated their current dynamic navigation items.
  const fallbackIndex = navigationItems.findIndex((dni) => {
    const dniUrl = new URL(dni.completeSlug, globalThis.location.origin);
    const dynamicItemSearchParams = new URLSearchParams(dniUrl.search);
    const {
      detailsDiscriminator: dynamicItemDetailsDiscriminator,
      detailsValue: dynamicDetailsValue,
    } = getDetailsFromSearchParams(dynamicItemSearchParams);
    if (
      dynamicItemDetailsDiscriminator == null ||
      dynamicItemDetailsDiscriminator !== detailsDiscriminator ||
      dynamicDetailsValue == null ||
      dynamicDetailsValue !== detailsValue
    ) {
      return false;
    }

    return locationPathname.startsWith(dniUrl.pathname);
  });
  return fallbackIndex === -1 ? undefined : fallbackIndex;
}
